<template>
    <div>
         <p class="bigTitle"><span class="floor">*</span>销售统计</p>
         <div class="body">
             <div class="title">
                <div class="block">
                    <span class="demonstration">起始时间:</span>
                    <el-date-picker v-model="value1" type="daterange" range-separator="至" start-placeholder="开始日期"  end-placeholder="结束日期"></el-date-picker>
                    <el-button type="primary" class="">搜索</el-button>
                </div>
             </div>
                 
             <div class="Info">
                   <div class="infoLeft">
                        <div class="top">
                            <p class="topP">平台收益</p>
                            <div class="topLeft">
                                 <img class="topLeftImg" src="https://7ouou-guide.oss-cn-chengdu.aliyuncs.com/common/Hotel/hear.jpg">
                            </div>
                            <div class="topRight">
                                <p class="topRightA">累计收益:$666666</p>
                                <p class="topRightB">累计佣金:$666666</p>
                            </div>
                        </div>
                        <div class="right">
                            <p class="topP">平台订单</p>
                            <div class="topLeft">
                                 <img class="topLeftImg" src="https://7ouou-guide.oss-cn-chengdu.aliyuncs.com/common/Hotel/hear.jpg">
                            </div>
                            <div class="topRight">
                                <p class="topRightA">累计收益:$666666</p>
                                <p class="topRightB">累计佣金:$666666</p>
                            </div>
                        </div>
                   </div>
                   <div class="inforight">
                        <div class="conten">
                                <p class="contenP">房型订单量</p>
                        </div>
                   </div>
             </div>
         </div>
    </div>
</template>

<script>
  export default {
    data() {
      return {
        inputs: 226,
        value1: '',
        value: '',
        value2: ''
      };
    },
    methods: {
    // 修改table header的背景色
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return 'background-color: #409EFF;color: #fff'
      }
    }
  }
  };
</script>

<style scoped>

.title{
    background-color: #FFFFFF
}

.block{
    background-color: #FFFFFF;
    padding-top: 1%;
    padding-bottom: 1%;
}

.Info{
    border-radius: 5px;
    margin-top: 1%;
    width: 100%;
}

.infoLeft{
    float: left;
    width: 48%;
}

.inforight{
    width: 50%;
    margin-left: 50%;
    padding-top: 0.1%;
}


.top{
    background-color: #FFFFFF;
    border-radius: 10px;
}

.right{
    background-color: #FFFFFF;
    border-radius: 10px;
}


.topP{
    padding-top: 1%;
}



.topLeft{
    float: left;
    width: 40%;

}

.topRight{
    height: 70%;
}

.topRightA{
    padding-top: 8%;
    padding-right: 20%;
}

.topRightB{
    padding-right: 20%;
    margin-bottom: 15%;
}


.topLeftImg{
    padding-left: 30%;
    border-radius: 5px;
}

.contenP{
    padding-top: 1%;
    padding-bottom: 67%;
}

.conten{
    background-color: #FFFFFF;
    border-radius: 10px;
}


.body{
    border-radius: 10px;
}

</style>


// WEBPACK FOOTER //
// src/components/Hotel/product/sell/sellSum.vue